import * as yup from 'yup';
import { requiredErrorMessage } from '@common/schema';
import { t } from 'i18next';
import {
  MAXIMUM_TEXT_AREA_LENGTH,
  TASK_MAX_RECORDED_MINUTES,
} from '@common/types/constants.ts';

export const addCareNoteSchema = yup.object().shape({
  note_type: yup
    .string()
    .oneOf(['Email', 'Phone call', 'In person', 'Reflection', 'Text', 'Other'])
    .required(requiredErrorMessage),
  program_id: yup.string(),
  provider_id: yup.string().optional(),
  notable_call: yup.boolean().optional(),
  recorded_minutes: yup
    .number()
    .typeError(t('patient.careNotes.modal.errors.recordedMinutesNumber'))
    .integer(t('patient.careNotes.modal.errors.recordedMinutesInteger'))
    .max(
      TASK_MAX_RECORDED_MINUTES,
      `Minutes must be smaller or equal to ${TASK_MAX_RECORDED_MINUTES}`,
    )
    .min(0, t('patient.careNotes.modal.errors.recordedMinutesMin'))
    .required(requiredErrorMessage),
  activity_minutes: yup
    .object({
      plan: yup.number().min(0).default(0),
      reconciliate: yup.number().min(0).default(0),
      coordinate: yup.number().min(0).default(0),
      educate: yup.number().min(0).default(0),
      communicate: yup.number().min(0).default(0),
    })
    .optional(),
  note: yup
    .string()
    .required(requiredErrorMessage)
    .max(
      MAXIMUM_TEXT_AREA_LENGTH,
      `This input must be ${MAXIMUM_TEXT_AREA_LENGTH} characters or less. Please reduce the length to proceed.`,
    ),
});
